Drupal.behaviors.toybox_control = {
  // eslint-disable-next-line no-unused-vars
  attach: function (context, settings) {
    this.initSelects(context);
    this.initExpirationTags(context);
    this.initHiders(context);
  },

  // Finding items that has an expiration date, and set a helper class if
  // they are expired.
  // We do this in JS, to avoid any cache issues.
  // Setting the target date to tomorrow, as that is the logic in the view.
  initExpirationTags: function (context) {
    const targetDate = new Date();
    targetDate.setDate(targetDate.getDate() - 1);

    targetDate.setHours(23, 59);
    const targetDateTimestamp = Math.floor(targetDate.getTime() / 1000);

    context.querySelectorAll("[data-expiration-date]").forEach((item) => {
      const expirationDate = parseInt(
        item.getAttribute("data-expiration-date"),
        10,
      );

      if (expirationDate < targetDateTimestamp) {
        item.classList.add("is-expired");
      }
    });
  },

  // Looping through .js-control-hide elements and toggleHide() on click.
  initHiders: function (context) {
    const that = this;

    context
      .querySelectorAll(".js-control-hide:not(.is-initialized)")
      .forEach((element) => {
        element.classList.add("is-initialized");

        element.addEventListener("click", (event) => {
          event.preventDefault();
          that.toggleHide(element);
        });
      });
  },

  toggleHide: function (element) {
    const hideSelector = element.getAttribute("data-hide-selector");

    if (!hideSelector) {
      return;
    }

    // Looping through our items and toggling their hidden state.
    document.querySelectorAll(hideSelector).forEach((item) => {
      item.classList.toggle("is-hidden");
    });
  },

  // Looping through .js-control-select elements and chooseSelect() on click.
  initSelects: function (context) {
    const that = this;

    context
      .querySelectorAll(".js-control-select:not(.is-initialized)")
      .forEach((item) => {
        item.classList.add("is-initialized");

        const select = item.querySelector("select");
        const label = item.querySelector("span");

        select.addEventListener("change", () => {
          that.chooseSelect(select, label);
        });
      });
  },

  chooseSelect: function (select, label) {
    const selectedOption = select.options[select.selectedIndex];
    let labelText = "- Vælg -";

    if (selectedOption) {
      labelText = "text" in selectedOption ? selectedOption.text : labelText;

      if ("value" in selectedOption) {
        label.classList.remove("is-placeholder");
      } else {
        label.classList.add("is-placeholder");
      }
    }

    label.innerHTML = labelText;
  },
};
